module.exports = __webpack_public_path__ + "img/teacher.daa555d1.png";